<aside class="getting-started-aside" style="display:flex;flex-direction:column;gap:var(--wa-spacing-large);min-width:14rem;padding:0 var(--wa-spacing-large) var(--wa-spacing-large) var(--wa-spacing-large);position:sticky;top:var(--wa-spacing-large);">
	<div *ngIf="!useGradle" class="aside-snippet">
		<div class="aside-snippet-label" waCaption="s" waFontWeight="semibold" waText>BOM Import</div>
		<markdown [data]="mdContent_38" class="aside-snippet-code wa-body-s" clipboard></markdown>
	</div>
	<div *ngIf="useGradle" class="aside-snippet">
		<div class="aside-snippet-label" waCaption="s" waFontWeight="semibold" waText>BOM Import</div>
		<markdown [data]="mdContent_39" class="aside-snippet-code wa-body-s" clipboard></markdown>
	</div>
	<div *ngIf="!useGradle" class="aside-snippet">
		<div class="aside-snippet-label" waCaption="s" waFontWeight="semibold" waText>Plugin Dependency</div>
		<markdown [data]="mdContent_40" class="aside-snippet-code wa-body-s" clipboard></markdown>
	</div>
	<div *ngIf="useGradle" class="aside-snippet">
		<div class="aside-snippet-label" waCaption="s" waFontWeight="semibold" waText>Plugin Dependency</div>
		<markdown [data]="mdContent_41" class="aside-snippet-code wa-body-s" clipboard></markdown>
	</div>
	<div class="aside-snippet">
		<div class="aside-snippet-label" waCaption="s" waFontWeight="semibold" waText>module-info.java</div>
		<markdown [data]="mdContent_42" class="aside-snippet-code wa-body-s" clipboard></markdown>
	</div>
</aside>